var canvas: HTMLCanvasElement;
var context: CanvasRenderingContext2D;

//startpos
var pos = {
    x: 600,
    y: 400
}
enum Direction {
    Right = 1,
    Left, 
    Center,
    Boost
}

function getRandomInt(max: number) {
    return Math.floor(Math.random() * max);
  }

var cnt1 = 0;

var momDirection = Direction.Center; // pixels per second
var v_movement = 200; // pixels per second
var v_background = 220; // pixels per second

type Point = { x: number,y: number, sizex:number, sizey:number, dflag:boolean}
var liste:Point[] = [];
var failed:boolean = false;

// system variables
var last_tick_t = 0;
var width: number;
var height: number;
var keyStates: Set<string> = new Set();
var plop = new Audio('plop.wav');

var logo = new Image();
logo.src = "spaceship.png";

var logoleft = new Image();
logoleft.src = "spaceshipleft.png";

var logoright = new Image();
logoright.src = "spaceshipright.png";

var logoboost = new Image();
logoboost.src = "spaceshipboost.png";

var fail = new Image();
fail.src = "fail.png";

function draw() {
    context.resetTransform();
    context.clearRect(0, 0, width, height);
    //Background 
    context.fillStyle = `hsl(237, 61%, 19%)`
    context.fillRect(0, 0, width, height);
    //Stars
    if(failed == true){
        context.drawImage(fail, -180, -200);
    }
    

    context.fillStyle = `hsl(0, 100%, 100%)`
    
    for(let a of liste) {
        context.fillRect(a.x-(a.sizex/2), a.y-(a.sizey/2), a.sizex, a.sizex);
    }

    context.translate(pos.x, pos.y);
    if(momDirection == Direction.Left){
        context.drawImage(logoleft, -35, -35);
    }

    if(momDirection == Direction.Right){
        context.drawImage(logoright, -35, -35);
    }
    
    if(momDirection == Direction.Center){
        context.drawImage(logo, -35, -35);
    }

    if(momDirection == Direction.Boost){
        context.drawImage(logoboost, -35, -35);
    }
    


}

function update(dt: number) {
    if (pos.y < 35) {          //up down
        pos.y = 35;
        plop.play();
    }
    if (pos.y > height - 35) {
        pos.y = height - 35;
        plop.play();
    }

    if (pos.x < 35) {              //left right
        pos.x = 35;
        plop.play();
    }
    if (pos.x > width - 35) {
        pos.x = width - 35;
        plop.play();
    }

    if (keyStates.has("ArrowUp")) {
        pos.y -= v_movement * dt;
        momDirection = Direction.Boost;
    }
    if (keyStates.has("ArrowDown")) {
        pos.y += v_movement * dt;
    }

    if (keyStates.has("ArrowLeft")) {
        // position
        pos.x -= v_movement * dt;
        momDirection = Direction.Left;
    }

    if (keyStates.has("ArrowRight")) {
        // position
        pos.x += v_movement * dt;
        momDirection = Direction.Right;
    }


    if (!keyStates.has("ArrowRight") && !keyStates.has("ArrowLeft") && !keyStates.has("ArrowUp")) {
        momDirection = Direction.Center;
    }
}

function Stars(dt: number) {
    for(let a of liste) {
        a.y += v_background * dt;
    }

    if(cnt1 == 10){
        liste.push({x:getRandomInt(width),y:-100, sizex:20+getRandomInt(20), sizey:10+getRandomInt(40),dflag:false});
        cnt1 = 0;
    }
    cnt1++;

    for(let a of liste) {
        if(a.y > height+100){
            a.dflag = true;
        }

    }

    for(let a of liste) {
        if(Math.abs(pos.x - a.x)< (25 + (a.sizex/2))   && Math.abs(pos.y - a.y)< (15 + (a.sizey/2)) ){
            failed = true;
            a.dflag = true;
        }
        
    }


    liste = liste.filter((e)=>!e.dflag)

}

function loop(t_ms: number) {
    // calculate dt
    let dt = t_ms - last_tick_t;
    last_tick_t = t_ms;

    update(dt / 1000); // to seconds
    Stars(dt / 1000);
    draw();

    window.requestAnimationFrame(loop);
}

function resized() {
    width = window.innerWidth;
    height = window.innerHeight;
    canvas.width = width;
    canvas.height = height;
}
function key(e: KeyboardEvent) {
    switch (e.type) {
        case "keydown":
            keyStates.add(e.key);
            break;
        case "keyup":
            keyStates.delete(e.key);
            break;
        default:
            console.warn("Wut?");
    }
}

function click(e: MouseEvent) {
    pos.x = e.offsetX;
    pos.y = e.offsetY;
}

function main() {
    canvas = document.getElementById("canvas") as HTMLCanvasElement;
    context = canvas.getContext("2d")!;
    window.addEventListener("keydown", key);
    window.addEventListener("keyup", key);
    window.addEventListener("resize", resized);
    canvas.addEventListener("click", click);
    resized();

    loop(performance.now());
}


main();